import UnicoUtils from "./script-utils.js";

(function ($) {
  /**
   * モーダル
   */
  const hideModal = (scrollTop) => {
    $('.js-modal').fadeOut();
    $('[id^="js-modal-target-"]').removeClass('is-showed');
    $('body').removeClass('is-fixed-modal').css({ top: 0 });
    $(window).scrollTop(scrollTop);
  };

  const showModal = (target, scrollTop) => {
    $(target).closest('.js-modal').fadeIn();
    $(target).addClass('is-showed');
    $('body').addClass('is-fixed-modal').css({
      top: - scrollTop
    });
  };

  const modalBind = () => {
    let scrollTop;
    $('a[href^="#js-modal-target-"]').on('click', (e) => {
      e.preventDefault();
      scrollTop = $(window).scrollTop();
      let modalTarget = $(e.target).attr('href');
      showModal(modalTarget, scrollTop);
      return false;
    });

    $('.js-modal').on('click', (e) => {
      if (!$(e.target).closest('[id^="js-modal-target-"]').length) {
        hideModal(scrollTop);
      }
    });

    $(document).on('click', '.js-modal-close', () => {
      hideModal(scrollTop);
    });
  }

  /**
   * パラメータ取得
   * @param {*} key キー
   * @returns パラメータ値
   */
  const getParam = (key) => {
    let url = new URL(window.location.href);
    let params = url.searchParams;
    return params.getAll(key);
  }

  /**
   * タブ切り替え
   */
  // 初期表示をセット
  function tabInit() {
    $('[id^="js-tab-target-"]').hide().removeClass('is-showed');
    for (let i = 0; i < $('.js-tab-group').length; i++) {
      const thisGroup = $('.js-tab-group').eq(i);
      for (let j = 0; j < thisGroup.find('[id^="js-tab-target-"]').length; j++) {
        const target = thisGroup.find('[id^="js-tab-target-"]').eq(j).attr('id');
        if (thisGroup.find(`a[href="#${target}"]`).hasClass('is-active')) {
          thisGroup.find(`#${target}`).eq(j).show().addClass('is-showed');
          break;
        };
      };
    };
    
    // 取得パラメータ値から初期表示のタブを設定
    const tabParams = getParam('tab');
    tabParams.forEach((tabParam) => {
      const activeTab = $(`a[href^="#js-tab-target-${tabParam}"]`);
      const activeTabContent = $(`#js-tab-target-${tabParam}`);
      requestAnimationFrame(() => {
        activeTab.siblings(`a[href^="#js-tab-target-"]`).removeClass('is-active');
        activeTab.addClass('is-active');
        activeTabContent.siblings().hide().removeClass('is-showed');
        activeTabContent.show('[id^="js-tab-target-"]').addClass('is-showed');
      })
    })
  };

  // タブ切り替えの処理
  function tabClassSwitch(group, target) {
    group.children('.tab-buttons').children('a[href^="#js-tab-target-"]').removeClass('is-active');
    group.find(`a[href="${target}"]`).addClass('is-active');
    group.children('.tab-panels').children('[id^="js-tab-target-"]').hide().removeClass('is-showed');
    group.find(target).show().addClass('is-showed');
  };

  function tabBind() {
    tabInit();

    $('a[href^="#js-tab-target-"]').on('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        $(document.scrollingElement).stop();
      }, 0);
      const group = $(e.target).closest('.js-tab-group');
      const target = $(e.target).attr('href');
      tabClassSwitch(group, target);
    });
  };


  /**
   * スライダー
   */
  function carouselSwiper() {
    let productsSwiper;
    let swiperBool;
    
    function carouselInit() {
      $('.js-products-carousel').each((index, element) => {
        productsSwiper = new Swiper(element, {
          loop: true,
          pagination: {
            el: element.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            nextEl: element.querySelector('.swiper-button-next'),
            prevEl: element.querySelector('.swiper-button-prev'),
          },
          paginationClickable: true,
          speed: 1000,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            waitForTransition: false,
          },
          centeredSlides: true,
        });
      });
    }

    if (UnicoUtils.isSP()) {
      carouselInit();
      swiperBool = true;
    } else if (UnicoUtils.isPC()) {
      swiperBool = false;
    }

    function mediaChange() {
      if (UnicoUtils.isSP()) {
        carouselInit();
        swiperBool = true;
      } else if (UnicoUtils.isPC()) {
        productsSwiper.destroy(false, true);
        swiperBool = false;
      }
    }
    window.addEventListener("resize", () => mediaChange());
  }


  /**
   * アコーディオン
   */
  function accordion() {
    $('.js-accordion').find('.js-accordion-trigger').each(function () {
      if (!$(this).closest('.js-accordion').hasClass('is-opened')) {
        $(this).siblings('.js-accordion-content').hide();
      }
      $(this).on('click', function () {
        if ($('+.js-accordion-content', this).not(':animated').length > 0) {
          $('+.js-accordion-content', this).slideToggle();
          $(this).closest('.js-accordion').toggleClass('is-opened');
        }
        return false;
      });
    });

    function mediaChange() {
      document.querySelectorAll('.js-accordion').forEach(element => {
        if (element.dataset.targetDevice === 'mobile') {
          if (UnicoUtils.isPC()) {
            element.querySelector('.js-accordion-content').style.display = 'block';
          } else {
            if (!element.classList.contains('is-opened')) {
              element.querySelector('.js-accordion-content').style.display = 'none';
            }
          }
        }
      });
    }

    mediaChange();
    window.addEventListener("resize", () => mediaChange());
  }

  /**
   * ready処理
   */
  $(function() {
    modalBind();
    tabBind();
    carouselSwiper();
    accordion();
  });

})(window.jQuery);
